import * as yup from "yup";

import { HOUR, MINUTES } from "../../../../constants/common";
import {
    addressRegEx,
    emailRegEx,
    messageRegEx,
    nameRegEx,
    passRegEX,
    phoneRegEx,
    pinRegEx,
} from "../../../../constants/regularExpression";
export const contactUsFormValidator = yup.object().shape({
    firstName: yup
        .string()
        .required()
        .min(3)
        .max(50)
        .matches(
            nameRegEx,
            "First name should start with letter and not contain any special characters or numbers"
        )
        .label("First name"),
    lastName: yup
        .string()
        .required()
        .min(3)
        .max(50)
        .matches(
            nameRegEx,
            "Last name should start with letter and not contain any special characters or numbers"
        )
        .label("Last name"),
    email: yup
        .string()
        .required()
        .email()
        .matches(emailRegEx, "Required valid email")
        .label("Email"),
    phoneNumber: yup
        .string()
        .required()
        .matches(phoneRegEx, "Required valid Indian phone number")
        .max(10)
        .label("Phone number"),
    enquiry: yup.string(),
    queryMessage: yup.string().when("enquiry", {
        is: "Other",
        then: (schema) =>
            schema
                .required()
                .matches(
                    messageRegEx,
                    "Query should start with alphanumeric characters and contains only number letters or (,.-) symbols"
                )
                .min(3)
                .max(250)

                .label("Query message"),
        otherwise: (schema) => schema,
    }),
});

export const loginWithPasswordValidator = yup.object().shape({
    username: yup
        .string()
        .required()
        .test(
            "is-valid-username",
            "Username must be valid email or phone number",
            (value) => {
                if (!value) return false;
                return emailRegEx.test(value) || phoneRegEx.test(value);
            }
        )
        .label("Email/Phone"),

    password: yup
        .string()
        .required()
        .min(8)
        .matches(
            passRegEX,
            "Password should be min 8 char, with at least 1  special char, 1 upper and 1 lower case letters and a number!"
        )
        .label("Password"),
});
export const loginWithOTPValidator = yup.object().shape({
    username: yup
        .string()
        .required()
        .test(
            "is-valid-username",
            "Username must be valid email or phone number",
            (value) => {
                if (!value) return false;
                return emailRegEx.test(value) || phoneRegEx.test(value);
            }
        )
        .label("Email/Phone"),
});

export const addressCityStatePinCodeSchemaShape = {
    address: yup
        .string()
        .required()
        .matches(
            addressRegEx,
            "Address should start with alphanumeric chars or letters and may contain (,-) "
        )
        .label("Address"),
    city: yup.string().required().max(100).label("City"),
    state: yup.string().required().max(80).label("State"),
    pincode: yup
        .string()
        .required()
        .matches(pinRegEx, "Pincode must be valid format")
        .label("Pincode"),
};
export const signupWithPasswordValidator = yup.object().shape({
    ...addressCityStatePinCodeSchemaShape,
    name: yup
        .string()
        .required()
        .min(3)
        .max(50)
        .matches(
            nameRegEx,
            "Name should start with letter and not contain any special characters or numbers"
        )
        .label("Full name"),

    password: yup
        .string()
        .required()
        .min(8)
        .matches(
            passRegEX,
            "Password should be min 8 char, with at least 1  special char, 1 upper and 1 lower case letters and a number!"
        )
        .label("Password"),

    electricalBill: yup
        .number()
        .min(10000, "Electricity bill must be greater than or equal to 10,000")
        .max(
            1000000,
            "Electricity bill must be less than or equal to 10,00,000"
        )
        .required()
        .label("Electricity bill"),
});

export const enquiryValidator = yup.object().shape({
    name: yup
        .string()
        .required()
        .min(3)
        .max(50)
        .matches(
            nameRegEx,
            "Name should start with letter and not contain any special characters or numbers"
        )
        .label("Full name"),
    email: yup
        .string()
        .required()
        .email()
        .matches(emailRegEx, "Required valid email")
        .label("Email"),
    mobile: yup
        .string()
        .required()
        .matches(phoneRegEx, "Required valid Indian mobile number")
        .max(10)
        .label("Mobile"),
    locationPincode: yup
        .number()
        .typeError("Invalid pincode format")
        .min(
            400000,
            "We are not live in this area yet. Please enter a valid pincode"
        )
        .max(
            445999,
            "We are not live in this area yet. Please enter a valid pincode."
        )
        .required()
        .label("Pincode"),
    averageMonthlyBill: yup
        .number()
        .typeError("Average monthly bill  must be valid number")
        .min(
            10000,
            "Average monthly bill must be greater than or equal to 10,000"
        )
        .max(
            1000000,
            "Average monthly bill must be less than or equal to 10,00,000"
        )
        .required()
        .label("Average monthly bill"),
});

let nameEmailPhoneObject = {
    name: yup
        .string()
        .required()
        .min(3)
        .max(50)
        .matches(
            nameRegEx,
            "Name should start with letter and not contain any special characters or numbers"
        )
        .label("Full name"),
    email: yup
        .string()
        .required()
        .email()
        .matches(emailRegEx, "Required valid email")
        .label("Email"),
    phone: yup
        .string()
        .required()
        .matches(phoneRegEx, "Required valid Indian phone number")
        .max(10)
        .label("Phone"),
};

export const addUserValidator = yup.object().shape(nameEmailPhoneObject);

export const enquiryNameAndBillSchema = yup.object().shape({
    name: yup
        .string()
        .required()
        .min(3)
        .max(50)
        .matches(
            nameRegEx,
            "Name should start with letter and not contain any special characters or numbers"
        )
        .label("Full name"),
    billAmount: yup
        .number()
        .typeError("Bill  must be valid number")
        .min(500, "Bill must be greater than or equal to 500")
        .max(10000000, "Bill must be less than or equal to 1Cr")
        .required()
        .label("Bill"),
    date: yup.date().required().label("Survey Date"),
    hour: yup
        .number()
        .required()
        .oneOf(HOUR.map((item) => item.value))
        .label("Hour"),
    minutes: yup
        .number()
        .required()
        .oneOf(MINUTES.map((item) => item.value))
        .label("Minutes"),
});

export const InsightformSchema = yup.object().shape({
    password: yup
        .string()
        .required()
        .min(8)
        .matches(
            passRegEX,
            "Password should be min 8 char, with at least 1  special char, 1 upper and 1 lower case letters and a number!"
        )
        .label("Password"),

    email: yup
        .string()
        .required("Email is required")
        .email("Invalid email address"),

    inverter: yup.string().required("Please select an option"),
});

export const ReminderFormSchema = yup.object().shape({
    message: yup
        .string()
        .required("Message is required")
        .test("min-chars", "It must be at least 10 characters", (value) => {
            if (!value) return false;
            return value.trim().length >= 10;
        }),
    date: yup.date().required("Date is required"),
    hour: yup.string().required("Hour is required"),
    minutes: yup.string().required("Minute is required"),
});

export const NotesFormStep1Schema = yup.object().shape({
    visitType: yup.string().required("Visit type is required"),
    date: yup.date().required("Date is required"),
    hour: yup.string().required("Hour is required"),
    minutes: yup.string().required("Minute is required"),
});

export const FreshNotesFormSchema = yup.object().shape({
    panelBrand: yup.string().required("Panel Brand is required"),
    inverterName: yup.string().required("Inverter is required"),
    connectionPhase: yup.string().required("Connection Phase is required"),
    customerComment: yup.string(),
});

export const FollowUpNotesFormSchema = yup.object().shape({
    followupType: yup.string().required("Follow Up Type is required"),
    message: yup
        .string()
        .required("Meeting Message are required")
        .test("min-chars", "It must be at least 10 characters", (value) => {
            if (!value) return false;
            return value.trim().length >= 10;
        }),
    actionTaken: yup
        .string()
        .required("Action Taken are required")
        .test("min-chars", "It must be at least 10 characters", (value) => {
            if (!value) return false;
            return value.trim().length >= 10;
        }),
    proposalStage: yup
        .string()
        .oneOf(["hot", "cold", "mild"], "Stage must be Hot, Cold, or Mild")
        .required("Proposal Stage is required"),
});

export const generateProposalValidationSchema = yup.object().shape({
    selectedConnectionType: yup
        .string()
        .required("Connection Type is required"),
    consumersBill: yup
        .number()
        .typeError("Bill  must be valid number")
        .required("Consumer's Bill is required")
        .min(100, "Consumer's Bill must be at least 100"),
    totalUnits: yup
        .number()
        .typeError("Total units  must be valid number")
        .required("Total Units is required")
        .moreThan(10, "Total Units must be greater than 10"),
    checkedState: yup
        .object()
        .test(
            "at-least-one-checked",
            "At least one proposal type must be selected",
            (value) => value && Object.values(value).some((v) => v === true)
        ),
});

export const reassignFormValidationSchema = yup.object().shape({
    assignee: yup.string().required("Project Assignee is required"),
    surveyor: yup.string().required("Surveyor Name is required"),
    date: yup.date().required("Survey Date is required"),
    hour: yup.string().required("Hour is required"),
    minutes: yup.string().required("Minutes are required"),
    contactPerson: yup.string().required("Contact Person Name is required"),
    contactPhoneNo: yup
        .string()
        .required()
        .matches(phoneRegEx, "Required valid Indian phone number")
        .max(10)
        .label("Phone"),
});

export const ProjectFormSchema = yup.object().shape({
    projectName: yup.string().required("Project Name is required"),
    address: yup.string().required("Address is required"),
    city: yup.string().required("City is required"),
    state: yup.string().required("State is required"),
    pincode: yup
        .string()
        .matches(/^\d{6}$/, "Pincode must be exactly 6 digits")
        .required("Pincode is required"),
});
/* @TODO => test before prod @habib610 Fri June 06,2025 */
export const getEnquiryValidationSchema = (useManualAddress, getOtp) =>
    yup.object().shape({
        name: yup.string().required("Full name is required"),
        electricalBill: yup.number().required("Bill amount is required"),
        // date: yup.date().required("Survey date is required"),
        projectName: yup.string(),
        address: useManualAddress
            ? yup.string().required("Address is required")
            : yup.string(),
        city: useManualAddress
            ? yup.string().required("City is required")
            : yup.string(),
        state: useManualAddress
            ? yup.string().required("State is required")
            : yup.string(),
        pincode: useManualAddress
            ? yup.string().required("Pincode is required")
            : yup.string(),
        otp: getOtp ? yup.string().required("OTP is required") : yup.string(),
    });

export const adminEnquiryValidationSchema = (
    currentStep,
    useManualAddress,
    maxDate
) => {
    return yup.object().shape({
        ...(currentStep === 1 && {
            name: yup.string().trim().required("Name is required"),
            date: yup.date().required("Survey Date is required"),
            hour: yup.string().required("Hour is required"),
            minutes: yup.string().required("Minutes are required"),
            electricalBill: yup
                .string()
                .required("Electricity Bill is required")
                .test(
                    "is-number",
                    "Bill must be valid number",
                    (val) => !isNaN(val) && val.trim() !== ""
                ),
        }),

        ...(currentStep > 1 && {
            // date: yup
            //     .date()
            //     .required("Date is required")
            //     .typeError("Date is invalid!")
            //     .min(new Date(), "Past date is invalid!")
            //     .max(maxDate, "Date can't be more than 2 weeks!"),

            ...(useManualAddress
                ? {
                      projectName: yup
                          .string()
                          .required("Project Name is required"),
                      address: yup.string().required("Address is required"),
                      city: yup.string().required("City is required"),
                      state: yup.string().required("State is required"),
                      pincode: yup
                          .string()
                          .required("Pin code is required")
                          .matches(pinRegEx, "Invalid pin code"),
                  }
                : {
                      address: yup.string().required("Address is required"),
                  }),
        }),
    });
};

export const onboardingValidationSchema = (currentStep, useManualAddress) => {
    return yup.object().shape({
        ...(currentStep === 1 && {
            name: yup.string().required("Name is required"),
            password: yup.string().required("Password is required"),
        }),

        ...(currentStep === 2 && {
            electricalBill: yup
                .string()
                .required("Electrical Bill is required"),

            billingName: yup.string().required("Billing Name is required"),

            ...(useManualAddress
                ? {
                      customAddress: yup
                          .string()
                          .required("Custom Address is required"),
                      city: yup.string().required("City is required"),
                      state: yup.string().required("State is required"),
                      pincode: yup
                          .string()
                          .required("Pincode is required")
                          .matches(pinRegEx, "Invalid pincode"),
                  }
                : {
                      address: yup.string().required("Address is required"),
                  }),
        }),
    });
};

export const CommuneInvestmentSchema = yup.object().shape({
    llpName: yup
        .string()
        .required("LLP Name is required")
        .matches(
            /^[A-Za-z0-9]+$/,
            "LLP Name must contain only letters and digits"
        ),

    paymentCollection: yup
        .string()
        .required("Payment collection method is required"),

    bankAccountName: yup
        .string()
        .required("Bank account name is required")
        .matches(
            /^[A-Za-z0-9]+$/,
            "Bank account Name must contain only letters and digits"
        )
        .test(
            "match-llp-name",
            "Bank account name must match LLP name",
            function (value) {
                const { llpName } = this.parent;
                return value === llpName;
            }
        ),

    bankAccountNumber: yup
        .string()
        .required("Bank account number is required")
        .matches(/^\d+$/, "Bank account number must be digits only")
        .min(6, "Bank account number must be at least 6 digits"),

    bankAccountType: yup.string().required("Bank account type is required"),

    razorpayTransferAccount: yup
        .string()
        .when("paymentCollection", (paymentCollection, schema) => {
            return paymentCollection === "PAYMENT_GATEWAY"
                ? schema
                      .required("Razorpay Transfer Account is required")
                      .matches(
                          /^acc_[A-Za-z0-9]+$/,
                          "Razorpay Transfer Account must start with 'acc_' and contain only letters and digits"
                      )
                : schema.notRequired();
        }),
});
